import { Icon } from "@iconify/react";
import { useState, useEffect } from "react";
import { ToggleMenuButton } from "../..";
import { useTranslation } from "react-i18next";
import { path } from "../../../utils/common/constant";

const MobileSidebar = ({
  sidebar,
  toggleSidebar,
  activeIndex,
  navigate,
  handleMenuClick,
  items,
}) => {
  const { t } = useTranslation();
  const [openDropdowns, setOpenDropdowns] = useState({});
  const [selectedDropdown, setSelectedDropdown] = useState(null);

  const toggleDropdown = (key) => {
    setOpenDropdowns((prev) => ({
      ...prev,
      [key]: !prev[key],
    }));
  };

  useEffect(() => {
    // Lock scroll when sidebar is open
    if (sidebar) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }

    // Cleanup function to reset overflow on unmount
    return () => {
      document.body.style.overflow = "auto";
    };
  }, [sidebar]);
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024 && sidebar) {
        // Close sidebar when change from mobile to desktop screen size
        toggleSidebar(false);
        document.body.style.overflow = "auto";
      }
    };

    window.addEventListener("resize", handleResize);

    // Cleanup when component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [sidebar, toggleSidebar]);

  return (
    <div className="lg:hidden flex flex-col items-center justify-center">
      {/* Hamburger Menu Button */}
      <ToggleMenuButton isOpen={sidebar} onClick={toggleSidebar} />

      {/* Overlay */}
      <div
        className={`fixed inset-0 transition-opacity duration-300 ${
          sidebar ? "opacity-50 z-30" : "opacity-0 pointer-events-none -z-10"
        }`}
        onClick={toggleSidebar}
      />

      {/* Sidebar Content */}
      <div
        className={`fixed top-[80px] right-0 h-full w-full bg-white shadow-lg transition-opacity duration-500 z-40 ${
          sidebar ? "opacity-100 z-40" : "opacity-0 pointer-events-none -z-10"
        }`}
      >
        {/* Navigation Links */}
        <nav className="px-16 pv:max-ph:px-2 ">
          {[
            { name: t("HeaderHome"), path: path.common.HOME },
            { name: t("HeaderAbout"), path: path.common.ABOUT },
            {
              name: t("HeaderService"),
              path: path.common.SERVICES,
              hasDropdown: true,
            },
            { name: t("HeaderCSR"), path: path.common.BLOG },
            { name: t("HeaderCareer"), path: path.common.CAREER },
            { name: t("HeaderPartners"), path: path.common.PARTNERS },
            { name: t("HeaderContact"), path: path.common.CONTACT },
            // { name: t("HeaderSoko"), path: path.common.SOKO },
          ].map((item, index) => (
            <div key={index} className="border-b border-gray-400 ">
              {item.hasDropdown ? (
                <div className="h-fit">
                  <button
                    className={`flex items-center justify-between text-primary w-full py-4 ${
                      selectedDropdown === item.name ? " text-primary" : ""
                    }`}
                    onClick={() => toggleDropdown(item.name)}
                  >
                    <span className="text-2xl font-medium uppercase text-primary">
                      {item.name}
                    </span>
                    <Icon
                      icon={
                        openDropdowns[item.name]
                          ? "mingcute:up-line"
                          : "mingcute:down-line"
                      }
                      className="w-4 h-4"
                    />
                  </button>

                  {/* Dropdown Items */}
                  <div
                    className={`overflow-hidden text-primary transition-all duration-300  ${
                      openDropdowns[item.name]
                        ? "max-h-64 sm:max-h-64"
                        : "max-h-0"
                    }`}
                  >
                    {items.map((dropdownItem) => (
                      <div
                        key={dropdownItem.key}
                        className="pl-4 py-2 text-2xl hover:bg-gray-50"
                        onClick={() => {
                          handleMenuClick({ key: dropdownItem.key });
                          toggleSidebar();
                          setSelectedDropdown(item.name);
                        }}
                      >
                        {dropdownItem.label}
                      </div>
                    ))}
                  </div>
                </div>
              ) : (
                <button
                  className={`w-full py-4 text-left text-2xl font-medium uppercase ${
                    activeIndex === index ? " text-secondary1" : "text-primary"
                  }`}
                  onClick={() => {
                    navigate(item.path);
                    toggleSidebar();
                    setSelectedDropdown(null);
                  }}
                >
                  {item.name}
                </button>
              )}
            </div>
          ))}
        </nav>
      </div>
    </div>
  );
};

export default MobileSidebar;
